<template>
  <div>
    <div class="banner">
      <img class="banner-bg-img" src="https://scheme.timesmedia.com.cn/activity/esg/bg_banner@2x.png" />
      <img class="banner-title-img" src="https://scheme.timesmedia.com.cn/activity/esg/title_banner@2x.png" />
    </div>
    <div class="main">
      <div class="main-background">
        <i class="background-icon" />
        <p class="background-title">活动背景</p>
        <p class="background-content">ESG ，即指环境（Environmental）、社会（Social）和治理（Governance）。它能有效地衡量企业的可持续发展能力，帮助投资者预判公司长期价值，ESG被越来越多的投资者视作企业的“第二张财报”。<br/>本次活动，由时代传媒集团主办，中央财经大学绿色金融国际研究院提供学术支持，时代周报、时代财经APP、时代商学院承办，双向赋能、强强联手，邀请知名经济学者，聚焦ESG最新发展动态，共同探讨高质量发展下的ESG实践。</p>
      </div>
      <div class="main-highlights">
        <span class="highlights-title">活动亮点</span>
        <div class="highlights-card-1" />
        <div class="highlights-card-2" />
        <div class="highlights-card-3" />
        <div class="highlights-card-4" />
      </div>
      <div class="main-process">
        <p class="process-title" />
        <div class="process-content">
          <div v-for="(item, index) in processList" :key="index" class="content-cell">
            <span class="cell-time">{{ item.time }}</span>
            <i class="cell-icon" />
            <div class="cell-summary">
              <p><strong>{{ item.label }}</strong></p>
              <p v-if="item.name"><strong>{{ item.name }}</strong></p>
              <p v-if="item.summary" style="font-size: 20px;line-height: 20px;">{{ item.summary }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="main-award">
        <i class="award-title" />
        <i class="award-bg" />
        <div class="award-content">
          <div v-for="(item, index) in awardList" :key="index" class="content-cell">
            <p class="cell-label">{{ item.label }}</p>
            <p class="cell-content">{{ item.content }}</p>
            <!-- <p class="cell-summary">{{ item.summary }}</p> -->
          </div>
        </div>
      </div>
      <div class="main-news">
        <div class="news-title" />
        <div class="news-content">
          <i class="next-icon" />
          <div @click="onLink(item.url)" v-for="(item, index) in newsList" :key="index" class="content-cell"><p>{{ item.label }}</p></div>
        </div>
      </div>
      <div class="main-organization">
        <p class="organization-title" />
        <div class="organization-content">
          <div v-for="(item, index) in organizationList" :key="index" class="content-cell">
            <p class="cell-label">{{ item.label }}</p>
            <p class="cell-summary">{{ item.summary }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img class="footer-bg-img" src="https://scheme.timesmedia.com.cn/activity/esg/bg-lianxi@2x.png" />
      <img class="footer-title-img" src="https://scheme.timesmedia.com.cn/activity/esg/title_lianxi@2x.png" />
      <img class="footer-qr-img" src="https://scheme.timesmedia.com.cn/activity/esg/erweima@2x.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      organizationList: [
        {
          label: '主办方单位：',
          summary: '广东时代传媒集团有限公司'
        },
        {
          label: '学术支持：',
          summary: '中央财经大学绿色金融国际研究院'
        },
        {
          label: '承办单位：',
          summary: '时代周报、时代财经APP、时代商学院'
        },
        {
          label: '特约赞助：',
          summary: '宁波银行'
        }
      ],
      processList: [
        {
          time: '13:30-14:00',
          label: '嘉宾签到'
        },
        {
          time: '14:00-14:10',
          label: '领导致辞',
        },
        {
          time: '14:10-14:30',
          label: '主题演讲一',
          name: '季晓南',
          summary: '国务院国有重点大型企业监事会原主席'
        },
        {
          time: '14:30-14:50',
          label: '主题演讲二',
          name: '施懿宸',
          summary: '中央财经大学绿色金融国际研究院副院长、中财绿指首席经济学家'
        },
        {
          time: '14:50-15:10',
          label: '主题演讲三',
          name: '冷冰',
          summary: '国际可持续准则理事会理事'
        },
        {
          time: '15:10-15:30',
          label: '主题演讲四',
          name: '戈峻',
          summary: '天九共享集团共同主席、天九企服董事长兼CEO'
        },
        {
          time: '15:30-15:50',
          label: '主题演讲五',
          name: '胡祚雄',
          summary: '凌雄科技董事会主席、小熊U租创始人'
        },
        {
          time: '15:50-16:10',
          label: '主题演讲六',
          name: '柴莹辉',
          summary: '同程旅行副总裁'
        },
        {
          time: '16:10-16:50',
          label: '圆桌对话',
          summary: '主题：ESG如何赋能企业高质量发展？'
        },
        {
          time: '16:50-17:00',
          label: '时代ESG与高质量发展研究院揭幕',
        },
        {
          time: '17:00-17:10',
          label: '时代ESG与高质量发展研究院聘任仪式',
        },
        {
          time: '17:10-17:20',
          label: '《ESG与高质量发展研究报告（2024）》发布',
        },
        {
          time: '17:20-17:40',
          label: 'ESG金羚奖颁奖典礼',
        },
        {
          time: '17:40',
          label: '论坛结束',
        },
      ],
      awardList: [
        {
          label: '2024年度ESG典范企业',
          content: '他们是践行ESG的领头羊，全面践行ESG理念，坚持可持续发展，在ESG全部考察维度中，受到各界普遍认可和推崇，堪称业界典范和标杆。',
          summary: '他们是中国ESG创新实践中全面领先的杰出企业。'
        },
        {
          label: '2024年度ESG社会责任实践领先企业',
          content: '在“社会责任”这一ESG重要考察维度中，他们践行企业社会责任，受到市场、投资者和监管部门的认可及赞赏，是中国ESG在社会责任领域创新实践的排头兵。',
          summary: '他们是中国ESG在社会责任领域创新实践的排头兵。'
        },
        {
          label: '2024年度ESG环境实践领先企业',
          content: '他们切实践行环保理念，不断提升资源利用效能，推动节能减排，助力实现企业与环境的共同可持续发展。他们是中国ESG在环境领域创新实践的先行者。',
          summary: '他们是中国ESG在环境领域创新实践的先行者。'
        },
        {
          label: '2024年度ESG治理实践领先企业',
          content: '以规范、全面、健全的ESG治理，推动企业规范运营，实现企业的可持续发展，他们是中国ESG在治理领域创新实践的探路者。',
          summary: '他们是绿色金融在中国推广、创新和实践的先锋。'
        },
        {
          label: '2024年度ESG绿色金融先锋企业',
          content: '他们不仅是绿色金融的推广、创新和实践的先锋，也积极倡导金融资源向绿色低碳领域倾斜，推动ESG与绿色金融的高质量发展。',
          summary: '他们是中国ESG在公司治理领域创新实践的探路者。'
        },
        {
          label: '2024年度ESG绿色制造先锋企业',
          content: '为推进绿色制造做出重大贡献，优化企业经济效益和社会效益协调发展，他们是绿色制造践行者、创新者和领先者。',
          summary: '他们引领中国ESG创新实践之风尚。'
        },
        {
          label: '2024年度ESG创新领军企业',
          content: '洞察发展趋势，追求自我革新，他们探寻中国企业ESG发展的新路径，探求企业ESG发展与实践的“中国方案”，引领中国ESG创新实践的新风尚。',
          summary: '他们是绿色制造在中国推广、创新和实践的先锋。'
        },
        {
          label: '2024年度ESG创新领军人物',
          content: '立足当下，也着眼未来，秉承长期主义，他们以ESG理念赋能企业高质量发展，为其他企业开展ESG实践提供有益借鉴，是引领企业高质量发展的领军人。',
          summary: '他们是中国ESG创新实践的企业领袖。'
        },
      ],
      newsList: [
        {
          label: '时代传媒集团成功举办“2024 ESG与高质量发展创新论坛” 助力ESG实践创新',
          url: 'https://epaper-h5.time-weekly.com/article?id=r87qnuet'
        },
        {
          label: '“2024 ESG与高质量发展创新论坛”成功举办 首届ESG金羚奖颁发',
          url: 'https://epaper-h5.time-weekly.com/article?id=n3gwonew'
        },
        {
          label: '拥抱新理念，提供新动能，ESG如何赋能企业高质量发展？',
          url: 'https://epaper-h5.time-weekly.com/article?id=7jg1zi4g'
        },
        {
          label: '季晓南：ESG可有效助力企业高质量发展，公司治理是其中重要抓手',
          url: 'https://epaper-h5.time-weekly.com/article?id=n3gzoekj'
        },
        {
          label: '专访小熊U租母公司凌雄科技董事会主席胡祚雄：以长期主义心态推进企业战略与ESG融合',
          url: 'https://epaper-h5.time-weekly.com/article?id=7jg9zkq3'
        },
        {
          label: '专访ISSB理事冷冰：可持续信息披露进入强制时代',
          url: 'https://epaper-h5.time-weekly.com/article?id=7jgwgy9l'
        },
        {
          label: '德勤中国谢安：A股ESG信披标准逐渐明确，将推动上市公司高质量发展',
          url: 'https://epaper-h5.time-weekly.com/article?id=2rq3ot1x'
        },
        {
          label: '施懿宸：ESG是衡量企业高质量发展的标尺',
          url: 'https://epaper-h5.time-weekly.com/article?id=ojgvjv0a'
        },
        {
          label: '专访周国银：ESG十大痛点仍普遍存在，企业应建立ESG五力模型组织架构',
          url: 'https://epaper-h5.time-weekly.com/article?id=9nekqc4k&shareType=90'
        },
        {
          label: 'APEC绿色供应链合作网络示范中心秘书长穆玲玲：推动供应商绿色化管理是企业ESG实践必修课',
          url: 'https://epaper-h5.time-weekly.com/article?id=9n8v3&shareType=90'
        },
        {
          label: '2023广州上市公司ESG发展与乡村振兴报告：约四成公司披露ESG报告，同比增长近50%',
          url: 'https://epaper-h5.time-weekly.com/article?id=g7j8z&shareType=90'
        },
        {
          label: '中兴通讯副总裁陈志萍：良好的ESG表现是企业高质量发展的内生动力',
          url: 'https://epaper-h5.time-weekly.com/article?id=qkx3g&shareType=90'
        },
        {
          label: '2023佛山上市公司ESG发展与乡村振兴报告：报告披露率为36%，同比提升近10个百分点',
          url: 'https://epaper-h5.time-weekly.com/article?id=z35dn&shareType=90'
        },
        {
          label: '2023深圳上市公司ESG与乡村振兴发展报告：超三成披露ESG报告，400亿元市值以上企业全覆盖',
          url: 'https://epaper-h5.time-weekly.com/article?id=ez61p&shareType=90'
        },
      ]
    }
  },
  methods: {
    onLink(link) {
      if (link) {
        window.open(link)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    display: block;
  }
  .banner {
    position: relative;
    width: 100%;
    .banner-bg-img {
      width: 100%;
    }
    .banner-title-img {
      position: absolute;
      width: 62%;
      margin: auto;
      top: 31%;
      left: 0;
      right: 0;
      z-index: 1;
    }
  }
  .footer {
    position: relative;
    width: 100%;
    .footer-bg-img {
      width: 100%;
    }
    .footer-title-img {
      position: absolute;
      width: 7.3%;
      margin: auto;
      top: 10.7%;
      left: 0;
      right: 0;
      z-index: 1;
    }
    .footer-qr-img {
      position: absolute;
      width: 12.3%;
      margin: auto;
      top: 32.5%;
      left: 0;
      right: 0;
      z-index: 1;
    }
  }
  .main {
    width: 1200px;
    margin: auto;
    .main-background {
      position: relative;
      width: 100%;
      padding: 100px 103px 24px 440px;
      .background-title {
        margin-bottom: 60px;
        font-family: 'fzcs';
        font-size: 36px;
        color: #163FA5;
        line-height: 36px;
        text-align: right;
      }
      .background-content {
        text-align: justify;
        font-size: 17px;
        color: #484951;
        line-height: 28px;
        word-break: break-all;
      }
      .background-icon {
        position: absolute;
        width: 357px;
        height: 106px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/title_activity@2x.png') no-repeat;
        background-size: 100% 100%;
        left: 0;
        top: 70px;
        z-index: 1;
      }
    }
    .main-highlights {
      position: relative;
      width: 1435px;
      height: 940px;
      margin-left: -235px;
      background: url('https://scheme.timesmedia.com.cn/activity/esg/bg_theme@2x.png') no-repeat;
      background-size: 100% 100%;
      .highlights-title {
        position: absolute;
        font-family: 'fzcs';
        font-size: 36px;
        color: #163FA5;
        line-height: 22px;
        top: 89px;
        right: 102px;
        z-index: 1;
      }
      .highlights-card-1 {
        position: absolute;
        width: 555px;
        height: 247px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/theme_1@2x.png') no-repeat;
        background-size: 100% 100%;
        top: 157px;
        right: 4px;
        z-index: 1;
      }
      .highlights-card-2 {
        position: absolute;
        width: 504px;
        height: 360px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/theme_2@2x.png') no-repeat;
        background-size: 100% 100%;
        top: 420px;
        right: 55px;
        z-index: 1;
      }
      .highlights-card-3 {
        position: absolute;
        width: 532px;
        height: 366px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/theme_3@2x.png') no-repeat;
        background-size: 100% 100%;
        top: 486px;
        right: 575px;
        z-index: 1;
      }
      .highlights-card-4 {
        position: absolute;
        width: 627px;
        height: 247px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/theme_4@2x.png') no-repeat;
        background-size: 100% 100%;
        top: 224px;
        right: 576px;
        z-index: 1;
      }
    }
    .main-process {
      width: 100%;
      height: 1851px;
      padding-top: 55px;
      background: url('https://scheme.timesmedia.com.cn/activity/esg/bg_liucheng@2x.png') no-repeat;
      background-size: 100% 100%;
      .process-title {
        width: 486px;
        height: 50px;
        margin: auto;
        margin-bottom: 57px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/title_liuchegn@2x.png') no-repeat;
        background-size: 100%;
      }
      .process-content {
        padding-left: 154px;
        .content-cell {
          display: flex;
          align-items: flex-start;
          &:not(:last-child) {
            margin-bottom: 28px;
          }
          .cell-time {
            width: 84px;
            margin-right: 66px;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
          }
          .cell-icon {
            width: 28px;
            height: 28px;
            margin-right: 57px;
            background: url('https://scheme.timesmedia.com.cn/activity/esg/process_clock@2x.png') no-repeat;
            background-size: 100% 100%;
          }
          .cell-summary {
            width: 710px;
            padding: 12px 48px;
            background: #67BE7B;
            border-radius: 4px;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 28px;
            > p:not(:last-child) {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .main-award {
      position: relative;
      width: 100%;
      padding: 248px 100px 17px 96px;
      .award-title {
        position: absolute;
        width: 200px;
        height: 90px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/title_prize@2x.png') no-repeat;
        background-size: 100% 100%;
        top: 112px;
        right: 98px;
        z-index: 1;
      }
      .award-bg {
        position: absolute;
        width: 366px;
        height: 1155px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/bg_prize@2x.png') no-repeat;
        background-size: 100% 100%;
        bottom: 0;
        left: 0;
        z-index: 1;
      }
      .award-content {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        width: 100%;
        z-index: 2;
        .content-cell {
          width: 400px;
          margin-bottom: 87px;
          .cell-label {
            margin-bottom: 44px;
            font-weight: bold;
            font-size: 20px;
            color: #1842A9;
            line-height: 20px;
          }
          .cell-content, .cell-summary {
            font-size: 16px;
            line-height: 28px;
          }
          .cell-content {
            color: #484951;
            margin-bottom: 10px;
            text-align: justify;
          }
          .cell-summary {
            color: #1842A9;
            line-height: 17px;
          }
        }
      }
    }
    .main-news {
      width: 100%;
      height: 384px;
      padding-top: 99px;
      background: url('https://scheme.timesmedia.com.cn/activity/esg/bg_news@2x.png') no-repeat;
      background-size: 100% 100%;
      .news-title {
        width: 142px;
        height: 90px;
        margin-bottom: 48px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/title_news@2x.png') no-repeat;
        background-size: 100% 100%;
        transform: translateX(96px);
      }
      .news-content {
        width: 100%;
        height: 134px;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-behavior: smooth;
        white-space: nowrap;
        user-select: none;
        // &::-webkit-scrollbar {
        //   width: 0 !important;
        // }
        // &::-webkit-scrollbar {
        //   width: 0 !important;
        //   height: 0 !important;
        // }
        .content-cell {
          position: relative;
          vertical-align: top;
          display: inline-block;
          width: 388px;
          height: 114px;
          margin-right: 31px;
          padding-left: 53px;
          padding-right: 16px;
          padding-top: 22px;
          background: #FFFFFF;
          border-radius: 3px;
          cursor: pointer;
          &::after {
            position: absolute;
            content: '';
            width: 11px;
            height: 11px;
            background: #B8C8EE;
            border-radius: 50%;
            left: 24px;
            top: 24px;
            z-index: 1;
          }
          > p {
            display: -webkit-box;
            width: 100%;
            text-align: justify;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }
        .next-icon {
          display: inline-block;
          width: 43px;
          height: 14px;
          margin-left: 26px;
          margin-right: 26px;
          margin-top: 52px;
          background: url('https://scheme.timesmedia.com.cn/activity/esg/news_jiantou@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .main-organization {
      width: 100%;
      padding: 66px 0 70px;
      .organization-title {
        width: 165px;
        height: 66px;
        margin: 0 auto 66px;
        background: url('https://scheme.timesmedia.com.cn/activity/esg/title_organization@2x.png') no-repeat;
        background-size: 100% 100%;
      }
      .organization-content {
        display: flex;
        justify-content: center;
        .content-cell {
          &:not(:last-child) {
            margin-right: 118px;
          }
          .cell-label {
            font-size: 20px;
            line-height: 26px;
            font-weight: bold;
            color: #1842A9;
          }
          .cell-summary {
            font-size: 16px;
            line-height: 26px;
            color: #666666;
          }
        }
      }
    }
  }
</style>
